import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/review/review.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/review_2024/move_review.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/review_2024/names_and_graph.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/blog/(posts)/review_2024/summary_and_metrics.png");
;
import(/* webpackMode: "eager", webpackExports: ["GameAPIProvider"] */ "/app/apps/royalur/src/components/api/GameAPIContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribeToRoyalListPrompt"] */ "/app/apps/royalur/src/components/blog/SubscribeToRoyalListPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnvProvider"] */ "/app/apps/royalur/src/components/env/EnvContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButton"] */ "/app/apps/royalur/src/components/layout/ShareButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/analysis/best.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/analysis/blunder.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/analysis/brilliant.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/analysis/excellent.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/analysis/forced.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/analysis/good.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/analysis/great.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/icons/analysis/mistake.svg");
